export default "__VITE_ASSET__CCPxKB23__"